import styled from "styled-components";
import COLORS from "../../constants/colors";
import FONTS from "../../constants/fonts";

export const StyledCompactSelectWrapper = styled.div`
    font-size: 14px;
    height: 46px;

    .select-container {
        height: 100%;
    }

    .select-control {
        font-size: 12px;
        height: 100%;
        outline: none;
        box-shadow: none;
        border: 1px solid rgba(35, 85, 252, 0.12);
        border-radius: 14px;
        background: #f9fafb;
        padding: 0 13px 0 12px;
        min-height: 46px;

        &:hover {
            border-color: rgba(35, 85, 252, 0.24);
            background: #ffffff;
        }
    }

    .select-value-container {
        padding: 0;
        overflow: hidden;
        height: 100%;
    }

    .select-singleValue {
        margin-left: 0;
        color: #0a0f1e;
        font-size: 14px;
        line-height: 20px;
    }

    .select-option {
        background-color: ${COLORS.WHITE};
        color: ${COLORS.GREY_1000};

        &:hover {
            color: ${COLORS.WHITE};
            background-color: ${COLORS.BLUE};
        }

        &.selected,
        &.focused {
            color: ${COLORS.WHITE};
            background-color: ${COLORS.BLUE};
        }

        &.disabled {
            color: ${COLORS.WHITE};
            background-color: ${COLORS.GREY_600};
            cursor: not-allowed;
        }
    }

    .select-input {
        input {
            caret-color: transparent;
        }
    }

    .select-control--searchable .select-input {
        color: #0a0f1e;
        cursor: text;

        input {
            caret-color: ${COLORS.BLUE};
            color: inherit;
            cursor: text;
            font-size: 16px;
            opacity: 1 !important;
        }
    }

    .select-placeholder {
        color: #5a6480;
        font-family: ${FONTS.REGULAR};
        font-size: 14px;
        line-height: 20px;
    }

    .select-dropDownIndicator {
        svg {
            width: 18px;
            height: 18px;
            transform: rotate(90deg);
        }
    }

    .select-customDropDownIndicator {
        padding: 0;
    }

    .select-noOptionMessage {
        color: ${COLORS.BLUE};
    }

    .select-customDropDownIndicator,
    .select-clear {
        cursor: pointer;
    }
`;

export default {};
